<template>
  <modal
    :show="opened"
    class="modal__wrapper_less-blur modal__wrapper modal-info modal-info_narrow"
    @modal:close="close"
  >
    <h3 class="form__subtitle">Изменение телефона</h3>
    <div class="form__description">
      <p>
        Вы указали номер <strong>{{ phone }}</strong>. Если это не&nbsp;ваш номер, введите действующий номер.
      </p>
    </div>
    <form @submit.prevent="submit">
      <smart-captcha ref="smartCaptcha" v-model="$v.form.captcha.$model">
        <template #errors>
          <div class="text-input__error">
            <div v-if="$v.form.captcha.$error">Необходимо пройти капчу</div>
          </div>
        </template>
      </smart-captcha>
      <div class="form-row form-row_1-col">
        <text-input
          label="Телефон"
          type="tel"
          name="phone"
          v-model="$v.form.mobilePhone.$model"
          :error="$v.form.mobilePhone.$error"
        >
          <template #errors>
            <div class="text-input__error" v-if="$v.form.mobilePhone.$error">
              <div v-if="!$v.form.mobilePhone.required">Заполните поле</div>
              <div v-if="!$v.form.mobilePhone.minLength">Недостаточное количество символов</div>
            </div>
          </template>
        </text-input>
      </div>

      <div class="form-row form-row_align-center">
        <button class="form__submit button button__lg button__blue" type="submit">
          Продолжить
        </button>
      </div>
    </form>
  </modal>
</template>

<script>
import {required, minLength} from "vuelidate/lib/validators";
import TextInput from "./TextInput.vue";
import api from "../services/api";
import SmartCaptcha from "./SmartCaptcha.vue";
import SmartCaptchaMixin from "../mixins/smartCaptchaMixin";
export default {
  name: "SignUpStepPhoneChangeModal",
  mixins: [SmartCaptchaMixin],
  components: {SmartCaptcha, TextInput},
  props: {
    opened: {
      type: Boolean,
      default: false
    },
    phone: {
      type: String
    }
  },
  data() {
    return {
      form: {
        mobilePhone: '',
        captcha: ''
      },
    }
  },
  validations() {
    const form = {
      mobilePhone: {
        required,
        minLength: minLength(18)
      },
      captcha: {required},
    }
    return { form };
  },
  watch: {
    opened(val) {
      if (val) {
        this.clearInput();
      }
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async submit() {
      await this.refreshCaptcha();

      this.$v.form.$touch();

      if (!this.$v.form.$pending && !this.$v.form.$invalid) {
        this.$store.dispatch('showLoader');

        try {
          await api.changePhone(this.form);

          this.$emit('change-phone', this.form.mobilePhone);
          this.$store.dispatch('hideErrorsBag');
          this.close();
        } catch (e) {
          this.$store.dispatch('setErrors', e);
          //await this.updateCaptchaOnError();
        } finally {
          this.$store.dispatch('hideLoader');
        }
      }
    },
    clearInput() {
      this.form.mobilePhone = '';
      this.$v.$reset();
    }
  }
}
</script>
